import { ErrorLink, onError } from '@apollo/client/link/error';
import { isUndefined } from 'src/utils/typeguards/isUndefined';
import { ERROR_PREFIXES } from 'src/common/constants';
import { handleInvoluntarySessionTermination } from 'src/services/auth/session/handleInvoluntarySessionTermination';
import { isUnauthenticatedStatusInResponse } from '../utils/isUnauthenticatedStatusInResponse';
export const GRAPHQL_SIGN_OUT_MESSAGE = 'An error has occurred. Please log in again';
export const GRAPHQL_SIGN_OUT_ERROR = 'User has been signed out due to unauthorized API response';

declare global {
    // eslint-disable-next-line no-var
    var signOutAlerted: boolean;
    interface Window {
        isDebugMode?: boolean;
    }
}
export class ErrorLinkHandlerError extends Error {
    type = 'ErrorLinkHandlerError';
    constructor(errorMessage: string) {
        const prefixedMessage = `${errorMessage}`;
        super(prefixedMessage);
        this.type = 'ErrorLinkHandlerError';
        this.name = 'ErrorLinkHandlerError';
        this.message = prefixedMessage;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).__proto__ = ErrorLinkHandlerError.prototype;
    }
}

const logToDatadog = async (error: unknown, context: object) => {
    const { datadog } = await import(
        /* webpackChunkName: "datadog" */
        'src/services/datadog'
    );
    datadog.addError(error, context);
};

export const onErrorHandler: ErrorLink.ErrorHandler = ({ graphQLErrors, networkError, operation, response }) => {
    if (!isUndefined(graphQLErrors) && graphQLErrors.length && isUnauthenticatedStatusInResponse(graphQLErrors)) {
        const error = new ErrorLinkHandlerError(`${ERROR_PREFIXES.APPLICATION_SESSION} ${GRAPHQL_SIGN_OUT_ERROR}`);
        logToDatadog(error, {
            graphQLErrorsAsString: JSON.stringify(graphQLErrors, null, 2),
            graphQLErrors,
            networkError,
            operation,
            response,
        });
        handleInvoluntarySessionTermination(GRAPHQL_SIGN_OUT_MESSAGE, 'Unauthorized response from server');
    } else {
        const error = new ErrorLinkHandlerError(`${ERROR_PREFIXES.APOLLO} Bad response from GraphQL Service`);
        logToDatadog(error, {
            graphQLErrorsAsString: JSON.stringify(graphQLErrors, null, 2),
            graphQLErrors,
            networkError,
            operation,
            response,
        });
    }
};

const createOnErrorLink = () => {
    // this is called once per page load, and lets us avoid alerting N times for N 4xx errors
    globalThis.signOutAlerted = false;
    return onError(onErrorHandler);
};
export { createOnErrorLink };
